export default __webpack_public_path__ + "static/media/kim.171e23a7.svg";